import { AfterViewInit, ElementRef, Input, ChangeDetectorRef } from "@angular/core";
import { ControlContainer, FormArray, FormGroup } from "@angular/forms";
import { onNextTick } from "@spscommerce/utils";

import { aggregateValidator } from "../../validators/aggregate.validator";

export abstract class SpsAbstractFieldsetComponent implements AfterViewInit {
    _fieldset: FormArray | FormGroup;

    @Input() formArrayName: string;
    @Input() formGroupName: string;

    constructor(
        protected _changeDetector: ChangeDetectorRef,
        protected _ctrlContainer: ControlContainer,
        public _elementRef: ElementRef
    ) {}

    ngAfterViewInit() {
        if (this._ctrlContainer) {
            let fieldset;

            if (this.formArrayName) {
                fieldset = <FormArray>this._ctrlContainer.control.get(this.formArrayName);
            } else if (this.formGroupName) {
                fieldset = <FormGroup>this._ctrlContainer.control.get(this.formGroupName);
            }

            if (fieldset) {
                const validators = [aggregateValidator];
                if (fieldset.validator) {
                    validators.push(fieldset.validator);
                }
                fieldset.setValidators(validators);

                onNextTick(() => {
                    // Overwriting this._fieldset or calling updateValueAndValidity() immediately
                    // can cause Angular "expression changed after checked" error
                    this._fieldset = fieldset;
                    fieldset.updateValueAndValidity();
                    this._changeDetector.markForCheck();
                });
            }
        }
    }
}
